import React from 'react';

import AppleLoginButton from '@components/AppleLoginButton/AppleLoginButton';
import Button from '@components/Button';
import GoogleLoginButton from '@components/GoogleLoginButton/GoogleLoginButton';

import './style.scss';

interface AuthMethodButtonsProps {
  onPhone: () => void;
  onGoogle: () => void;
  onApple: () => void;
  showApple?: boolean;
  className?: string;
}

const AuthMethodButtons: React.FC<AuthMethodButtonsProps> = ({
  onPhone,
  onGoogle,
  onApple,
  showApple = false,
  className = '',
}) => (
  <div className={`auth-method-buttons ${className}`.trim()}>
    <Button
      onClick={onPhone}
      bsStyle={'default' as ButtonStyle}
      content="Continue with Phone (SMS)"
      className="auth-method-buttons__button auth-method-buttons__button--phone"
    />
    <GoogleLoginButton onClick={onGoogle} className="auth-method-buttons__button" />
    {showApple && <AppleLoginButton onClick={onApple} className="auth-method-buttons__button" />}
  </div>
);

export default AuthMethodButtons;
